import React from 'react';
import { withTranslation } from 'react-i18next';

function RelatedItems(props) {
    const getCategory = (category) => {
        props.category(category)
    }
    const {t}= props
    return (
        <div className="relateditemblk">            
            <h5>{t('RecipeFinder_TryOneOfThese')}</h5>
            <div className="rlinks">
            {
                props.relateditems.map((item, index) => (
                    <span key={index} onClick={()=>getCategory(item.relatedName)}>
                        {item.relatedName}
                    </span>
                ))
            }
            </div>
        </div>
    );
}

export default withTranslation()(RelatedItems);